<app-breadcrumbs></app-breadcrumbs>
<div class="c-page-wrapper product-page">
  <div class="container">

    <div class="row main-row gx-custom-40-up-sm">
      @if((loading$ | async) || !product ){
      <div class="loader-wrapper">
        <p-progressSpinner styleClass="c-loader medium centered-vertically" strokeWidth="2" fill="var(--surface-ground)"
          animationDuration=".5s"></p-progressSpinner>
      </div>
      } @else {
      <div class="col-xl-4 col-lg-4 col-md-5 col-sm-12 gallery-col">
        <div class="d-md-none mb-12-px">
          <app-product-details-header [studdableTires]="studdableTires" [studdedTires]="studdedTires"
            [showLabels]="true" [name]="product.name" [slug]="product.slug"
            [manufacturer]="product.customAttributes?.manufacturer"
            [sku]="selectedVariant.sku || product.variants[0]?.sku"></app-product-details-header>
        </div>
        <app-gallery [showImageExplanation]="true" [images]="product?.assets"></app-gallery>
      </div>
      <div class="col-xl-5 col-lg-4 col-md-7 col-sm-12 info-col d-none d-md-block">
        <div class="d-none d-md-block">
          <app-product-details-header [studdableTires]="studdableTires" [studdedTires]="studdedTires"
            [showLabels]="true" [name]="product.name" [slug]="product.slug"
            [manufacturer]="product.customAttributes?.manufacturer"
            [sku]="selectedVariant.sku || product.variants[0]?.sku"></app-product-details-header>
        </div>
        @if(product.description){
        <div class="mt-16-px">
          <app-product-details-description [description]="product.description"></app-product-details-description>
        </div>
        }
        @if(product.customAttributes?.productAttributes?.length > 0){
        <div class="mt-22-px">
          <app-product-details-params [attributes]="product?.customAttributes?.productAttributes">
          </app-product-details-params>
        </div>
        }
      </div>
      <div class="col-xl-3 col-lg-4 col-md-12 price-and-actions-col">
        <app-price-and-actions-block [quantityEnabled]="false" [productVariant]="selectedVariant"
          [shippingMethods]="shippingMethods" [selectedAsset]="selectedAsset" [product]="product">
        </app-price-and-actions-block>
      </div>

      <div class="col-xl-5 col-lg-4 col-md-7 col-sm-12 info-col d-md-none">
        @if(product.description){
        <div class="mb-24-px">
          <app-product-details-description [description]="product.description"></app-product-details-description>
        </div>
        }

        @if(product.customAttributes?.productAttributes?.length > 0){
        <app-product-details-params [attributes]="product?.customAttributes?.productAttributes">
        </app-product-details-params>
        }

      </div>
      }
    </div>

    <!--
        <div class="row gx-custom-40-up-sm">
      <div class="col-xl-4 col-lg-12 col-md-12 p-unset-sm">
        <app-not-available-overlay>
          <app-ask-about-product></app-ask-about-product>
        </app-not-available-overlay>
      </div>

      <div class="col-xl-8 col-lg-12 p-unset-sm">

        <app-similar-products></app-similar-products>

      </div>
    </div>
    -->

  </div>
</div>
<!--<app-page-description></app-page-description>-->
